/**
 * A-Social 主应用组件
 * 小红书风格设计
 */

import { Routes, Route } from 'react-router-dom'
import { useEffect } from 'react'
import { IconDefs } from './components/common/Icons'
import { Sidebar, MobileNav } from './components/layout'
import { LoginModal } from './components/auth/LoginModal'
import { useAuthStore } from './stores/authStore'
import Toast from './components/common/Toast'

// 页面组件
import Landing from './pages/Landing'
import Home from './pages/Home'
import Publish from './pages/Publish'
import Lab from './pages/Lab'
import Profile from './pages/Profile'
import Settings from './pages/Settings'
import Dashboard from './pages/Dashboard'
import AgentProfile from './pages/Dashboard/AgentProfile'
import AgentConfig from './pages/Dashboard/AgentConfig'
import Notifications from './pages/Notifications'
import AuthCallback from './pages/AuthCallback'
import PostDetail from './pages/PostDetail'

function App() {
  const { checkSession, isLoggedIn, isLoading } = useAuthStore()

  useEffect(() => {
    checkSession()
  }, [checkSession])

  // Session 检查期间显示 loading 状态
  if (isLoading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="animate-spin w-8 h-8 border-2 border-[#FF2442] border-t-transparent rounded-full" />
      </div>
    )
  }

  // Landing Page for non-logged-in users (no sidebar)
  if (!isLoggedIn) {
    return (
      <div className="min-h-screen bg-white">
        {/* SVG 图标定义 */}
        <IconDefs />

        {/* Landing Page */}
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/post/:id" element={<PostDetail />} />
          <Route path="/auth/callback/x" element={<AuthCallback />} />
          {/* 其他路由显示 Landing 并提示登录 */}
          <Route path="*" element={<Landing />} />
        </Routes>

        {/* 全局登录弹窗 */}
        <LoginModal />

        {/* 全局Toast提示 */}
        <Toast />
      </div>
    )
  }

  // Main app for logged-in users
  return (
    <div className="min-h-screen bg-surface-bg flex overflow-x-hidden">
      {/* SVG 图标定义 */}
      <IconDefs />

      {/* 侧边栏 */}
      <Sidebar />

      {/* 主内容区域 */}
      <main className="main-content flex-1 ml-60 flex flex-col">
        {/* 页面内容 */}
        <div className="flex-1">
          <Routes>
            {/* 公开路由 */}
            <Route path="/" element={<Home />} />
            <Route path="/post/:id" element={<PostDetail />} />

            {/* OAuth 回调路由 */}
            <Route path="/auth/callback/x" element={<AuthCallback />} />

            {/* Dashboard 看板路由（需要登录） */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard/agent/:id" element={<AgentProfile />} />
            <Route path="/dashboard/agent/:id/config" element={<AgentConfig />} />

            {/* 需要登录的受保护路由 */}
            <Route path="/lab" element={<Lab />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/profile/:userId" element={<Profile />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="/publish" element={<Publish />} />
          </Routes>
        </div>
      </main>

      {/* 移动端底部导航 */}
      <MobileNav />

      {/* 全局登录弹窗 */}
      <LoginModal />

      {/* 全局Toast提示 */}
      <Toast />
    </div>
  )
}

export default App